import { formatUsStateName } from "@wags/utils/us-states.ts";
import type {
    CompatibilityResult,
    RequirementKind,
} from "../../compatibility/types.ts";

export type HardConflictReviewRow = {
    kind: RequirementKind;
    label: string;
};

export function selectHardConflictRows(
    result: CompatibilityResult,
    organizationState: string | null | undefined,
): HardConflictReviewRow[] {
    const seen = new Set<RequirementKind>();
    const rows: HardConflictReviewRow[] = [];

    for (const check of result.checks) {
        const { requirement } = check;
        if (
            check.status !== "unmet" ||
            requirement.severity !== "hard" ||
            seen.has(requirement.kind)
        ) {
            continue;
        }
        seen.add(requirement.kind);
        const stateName =
            requirement.kind === "in_state_only"
                ? formatUsStateName(organizationState)
                : undefined;
        rows.push({
            kind: requirement.kind,
            label:
                requirement.kind === "in_state_only"
                    ? stateName
                        ? `${stateName} adopters only`
                        : "In-state adopters only"
                    : requirement.label,
        });
    }

    return rows;
}
